module.exports = __webpack_public_path__ + "static/media/DeleteIcon.a86f9c2b.svg";